export const getNumberString = (value: string) => value.replace(/[^\d.]/g, '');
